export function checkIdCard(value){
    const provs = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外',
    };
    let iSum = 0
    if (!/^\d{17}(\d|x)$/i.test(value.replace(/\s+/g, ''))) {
        return false;
    }
    value = value.replace(/\s+/g, '').replace(/x$/i, 'a');
    // eslint-disable-next-line radix
    if (provs[parseInt(value.replace(/\s+/g, '').substr(0, 2))] == null) {
        return false;
    }
    // eslint-disable-next-line no-case-declarations
    const isBirthday = `${value.replace(/\s+/g, '').substr(6, 4)}-${Number(
        value.replace(/\s+/g, '').substr(10, 2),
    )}-${Number(value.replace(/\s+/g, '').substr(12, 2))}`;
    // eslint-disable-next-line no-case-declarations
    const d = new Date(isBirthday.replace(/-/g, '/'));
    if (isBirthday !== `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`) {
        return false;
    }
    // eslint-disable-next-line no-restricted-properties
    for (let i = 17; i >= 0; i--)
        iSum += (Math.pow(2, i) % 11) * parseInt(value.replace(/\s+/g, '').charAt(17 - i), 11);
    if (iSum % 11 !== 1) {
        return false;
    }
    return true
}

export function checkTelPhone(value){
    return /^1[3456789]\d{9}$/.test(value)
}

export function checkEmail(value) {
    return /^([a-zA-Z\d])(\w|\-|\.)*@[a-zA-Z\d]+\.[a-zA-Z]{2,6}$/.test(value)
}


// WEBPACK FOOTER //
// ./src/utils/validator.js